import React from "react";
import { HTMLRenderTemplate } from "themes/common/components";

function HTMLRender(props) {
    return <HTMLRenderTemplate {...props} />;
}

export default HTMLRender;
